import React, { SyntheticEvent } from 'react';
import cn from 'classnames';

import { Tooltip } from '@components/common';
import UserSpinner from '@components/common/UserSpinner';

import { IButtonProps } from './Button.types';

import './Button.scss';

const Button: React.FC<IButtonProps> = ({
	children,
	className,
	containerClassName,
	customColors,
	disabled,
	fullWidth,
	icon,
	isLoading,
	isShadow,
	large,
	onClick,
	secondary,
	text,
	tooltip,
	type,
	withoutBackground,
}) => {
	const classNames = cn('f5gButton', className, {
		'f5gButtonSecondary': secondary,
		'f5gButtonLarge': large,
		'f5gButtonWithoutBackground': withoutBackground,
		'f5gButtonWithShadow': isShadow,
		'f5gButtonWithIcon': !!icon,
		'f5gButtonDisabled': disabled,
		'f5gButtonFullWidth': fullWidth,
	});

	const containerClassNames = cn('f5gButtonContainer', containerClassName, {
		'fullWidth': fullWidth,
	});
	const onClickHandler = (e: SyntheticEvent) => {
		if (disabled || !onClick) return;

		e.stopPropagation();

		onClick();
	};

	return (
		<Tooltip
			content={tooltip}
			interactive
			isDisabled={!tooltip}
			placement='auto'
		>
			<div className={containerClassNames}>
				<button
					className={classNames}
					disabled={disabled}
					onClick={onClickHandler}
					style={!disabled && !!customColors
						? {
							backgroundColor: customColors.background,
							color: customColors.font,
						}
						: {}
					}
					type={type}
				>
					{isLoading
						? <UserSpinner size={24} />
						: (
							<>
								{!!icon && icon}{text || children}
							</>
						)}
				</button>
			</div>
		</Tooltip>
	);
};

export default Button;
